import { DocumentTemplate } from "@dune/types";
import {
	Button,
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	Input,
} from "@dune/ui";
import React, { useState } from "react";
import { toast } from "sonner";
import { useUpsertDocumentTemplate } from "../../../../api/mutations/documents.mutations";

interface UploadTemplateDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	templateId: string | null;
	templates?: DocumentTemplate[];
	onSuccess: () => void;
}

const UploadTemplateDialog: React.FC<UploadTemplateDialogProps> = ({
	open,
	onOpenChange,
	templateId,
	templates,
	onSuccess,
}) => {
	const [selectedFile, setSelectedFile] = useState<File | null>(null);
	const upsertTemplate = useUpsertDocumentTemplate();

	const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
		if (e.target.files?.[0]) {
			setSelectedFile(e.target.files[0]);
		}
	};

	const handleUpload = () => {
		if (!templateId || !selectedFile) return;
		const existing = templates?.find((t) => t.id === templateId);
		if (!existing) return;
		upsertTemplate.mutate(
			{
				name: existing.name,
				entityModel: existing.entityModel,
				templateType: existing.templateType,
				file: selectedFile,
			},
			{
				onSuccess: () => {
					toast.success("Version téléversée");
					setSelectedFile(null);
					onSuccess();
				},
			},
		);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-md">
				<DialogHeader>
					<DialogTitle>Téléverser une nouvelle version</DialogTitle>
					<DialogDescription>
						Sélectionnez un nouveau fichier .docx
					</DialogDescription>
				</DialogHeader>
				<Input type="file" accept=".docx" onChange={handleFileChange} />
				<DialogFooter>
					<Button variant="ghost" onClick={() => onOpenChange(false)}>
						Annuler
					</Button>
					<Button
						onClick={handleUpload}
						disabled={!selectedFile || upsertTemplate.isPending}
						isLoading={upsertTemplate.isPending}
					>
						Téléverser
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default UploadTemplateDialog;
